import React from "react";

/**
 * Delete confirmation component for Background Color
 * Displays a confirmation dialog before deleting a background
 */
const Delete = ({ formData, handleSubmit, onDiscard }) => {
  const rank = formData?.rank || "N/A";
  const colorHexCode = formData?.color_hex_code || "#000000";

  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this record?{" "}
        <b>
          <u>
            Rank: {rank} - Color: {colorHexCode}
          </u>
        </b>
      </h3>

      <div className="mt-4">
        <button
          type="button"
          className="btn bg-orange form-btn"
          onClick={handleSubmit}
          aria-label={`Confirm delete rank ${rank}`}
        >
          Yes
        </button>
        <button
          type="button"
          className="btn btn-secondary form-btn mx-3"
          onClick={onDiscard}
          aria-label="Cancel delete"
        >
          No
        </button>
      </div>
    </div>
  );
};

export default Delete;
